





import {Component} from "vue-property-decorator"
import {TimelineChartManager} from "@/charts/TimeLineChartManager"
import {BaseChartComponent} from "@/charts/BaseChartComponent"

@Component
export default class TimelineChart extends BaseChartComponent<TimelineChartManager> {
  createChartManager(): TimelineChartManager {
    return new TimelineChartManager(this.$refs.chartContainer as HTMLElement)
  }
}
